<template>
  <Segnalazioni />
</template>

<script>
import Segnalazioni from '@/components/PICKING/Segnalazioni.vue';

export default {
  name: 'PickingSegnalazioni',
  components: {
    Segnalazioni,
  },
}
</script>
